export const SUBSCRIPTION_STATUS_TRIAL = "trial";
export const SUBSCRIPTION_STATUS_ACTIVE = "active";
// will have this status until the end of the period
export const SUBSCRIPTION_STATUS_CANCELLATION_PENDING = "cancellation-pending";
export const SUBSCRIPTION_STATUS_CANCELLED = "cancelled";

export const SUBSCRIPTION_STATUSES = [
  SUBSCRIPTION_STATUS_TRIAL,
  SUBSCRIPTION_STATUS_ACTIVE,
  SUBSCRIPTION_STATUS_CANCELLATION_PENDING,
  SUBSCRIPTION_STATUS_CANCELLED,
] as const;

export const HOSTING_FEATURE_TRIAL_UP = "trial_up";
export const HOSTING_FEATURE_CUSTOM_DOMAIN = "custom_domain";
export const HOSTING_FEATURE_IP_ALLOWLIST = "ip_allowlist";
export const HOSTING_FEATURE_INVOICEABLE = "invoiceable";
export const HOSTING_FEATURE_CLICKHOUSE_DWH = "clickhouse_dwh";
const HOSTING_FEATURE_METABASE_API_KEY = "metabase_api_key";
const HOSTING_FEATURE_SEMANTIC_SEARCH_DB = "semantic_search_db";
export const HOSTING_FEATURE_METABASE_AI = "metabase_ai";
export const HOSTING_FEATURE_TRANSFORMS_BASIC = "transform_basic";
export const HOSTING_FEATURE_TRANSFORMS_ADVANCED = "transform_advanced";
export const HOSTING_FEATURES = [
  HOSTING_FEATURE_TRIAL_UP,
  HOSTING_FEATURE_CUSTOM_DOMAIN,
  HOSTING_FEATURE_IP_ALLOWLIST,
  "invoicing_eligibility",
  "can_have_dev_subscription",
  "is_dev_subscription",
  HOSTING_FEATURE_INVOICEABLE,
  HOSTING_FEATURE_CLICKHOUSE_DWH,
  HOSTING_FEATURE_METABASE_API_KEY,
  HOSTING_FEATURE_SEMANTIC_SEARCH_DB,
  HOSTING_FEATURE_METABASE_AI,
  HOSTING_FEATURE_TRANSFORMS_BASIC,
  HOSTING_FEATURE_TRANSFORMS_ADVANCED,
] as const;

export const METER_TRANSFORMS_BASIC_KEY = `${HOSTING_FEATURE_TRANSFORMS_BASIC}_runs`;
export const METER_TRANSFORMS_ADVANCED_KEY = `${HOSTING_FEATURE_TRANSFORMS_ADVANCED}_runs`;
export const METER_TRANSFORMS_KEYS = [
  METER_TRANSFORMS_BASIC_KEY,
  METER_TRANSFORMS_ADVANCED_KEY,
] as const;
export const METER_DWH_ROWS_KEY = "dwh:rows";
// Shared by the paid and free Metabase Track add-ons; they're mutually exclusive.
export const METER_PRODUCT_ANALYTICS_EVENTS_KEY = "product_analytics:event:v1";
export const METER_KEYS = [
  ...METER_TRANSFORMS_KEYS,
  METER_DWH_ROWS_KEY,
  METER_PRODUCT_ANALYTICS_EVENTS_KEY,
] as const;
